import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PageShell from '../components/PageShell';
import AuthCard from '../components/AuthCard';
import request from '../api';

function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setError('');
        setBusy(true);
        try {
            const data = await request('/admin/login', { method: 'POST', body: { username, password } });
            localStorage.setItem('adminToken', data.token);
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <PageShell
            title="Inicio de Sesión de Administrador"
            nav={<Button component={RouterLink} to="/auctions" color="inherit">Volver a Subastas</Button>}
            maxWidth="sm"
        >
            <AuthCard sx={{ textAlign: 'center' }}>
                <AdminPanelSettingsIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                <Box component="form" onSubmit={submit}>
                    <Stack spacing={2}>
                        <TextField
                            label="Usuario"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            fullWidth
                            required
                            autoFocus
                        />
                        <TextField
                            label="Contraseña"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            fullWidth
                            required
                        />
                        <Button type="submit" variant="contained" size="large" disabled={busy} fullWidth>
                            Iniciar Sesión
                        </Button>
                        {error && <Alert severity="error">{error}</Alert>}
                    </Stack>
                </Box>
            </AuthCard>
        </PageShell>
    );
}

export default AdminLogin;
